import ValidationModal from "./ValidationModal";
import { QUERY_STATUS } from "constants/constants";
import Proptypes from "prop-types";

const DocumentDownloadModal = ({ status, onClose }) => {
  return (
    <ValidationModal
      open={status !== QUERY_STATUS.INITIAL}
      status={status}
      onClose={onClose}
      messages={{
        pendingTitleId: "download_pending_title",
        pendingTitleDefault: "Téléchargement en cours...",
        pendingMessageId: "download_pending_message",
        pendingMessageDefault:
          "Votre document est en cours de téléchargement...",
        successTitleId: "download_success_title",
        successTitleDefault: "Téléchargement terminé",
        successMessageId: "download_success_message",
        successMessageDefault:
          "Votre document a été téléchargé avec succès.",
        errorTitleId: "download_error_title",
        errorTitleDefault: "Erreur",
        errorMessageId: "download_error_message",
        errorMessageDefault:
          "Une erreur est survenue lors du téléchargement de votre document.",
      }}
    />
  );
};

DocumentDownloadModal.propTypes = {
  status: Proptypes.string.isRequired,
  onClose: Proptypes.func.isRequired,
};

export default DocumentDownloadModal;
